export const useStyles = () => {
    return {
        styles: {
            container: {
                display: "flex",
                columnGap: "10px",
                justifyContent: "flex-end",
                flexWrap: "wrap",
                width:"100%"
            },
            autocomplete: {
                width: "100%",
               "& .MuiTextField-root":  {
                 width: "100%"
               }
            },
            dates: {
                display:"flex",
                alignItems: "center"
            },
        }
    }
}